import { PlaceholderValue } from 'next/dist/shared/lib/get-img-props';
import Image, { ImageProps } from 'next/image';

import { StrapiImage } from '@/lib/strapi';

export type AppImageProps = Omit<
    ImageProps,
    'src' | 'alt' | 'placeholder' | 'blurDataURL'
> & {
    format?: keyof StrapiImage['formats'];
    image: StrapiImage;
    placeholder?: boolean;
};

export function AppImage({
    placeholder = true,
    format,
    image,
    ...props
}: AppImageProps) {
    const {
        alternativeText,
        name,
        url,
        formats,
        placeholder: placeholderImage,
    } = image;

    return (
        <Image
            src={format ? (formats[format]?.url ?? url) : url}
            alt={alternativeText ?? name}
            width={image.width}
            height={image.height}
            placeholder={
                placeholder && placeholderImage
                    ? ((placeholderImage as PlaceholderValue) ?? undefined)
                    : undefined
            }
            {...props}
        />
    );
}
